// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__9BWOl","spinning":"Spinner_spinning__EbZID","inverted":"Spinner_inverted__Pnq1w"};